import formatFileSize from './utils'

const messages = {
  _default: () => `arvo ei kelpaa.`,
  after: (field, [target, inclusion]) =>
    `täytyy olla jälkeen ${inclusion ? 'tai yhtä suuri kuin' : ''} ${target}.`,
  alpha_dash: () =>
    `kenttä voi sisältää kirjaimia, numeroita sekä väli- ja alaviivoja.`,
  alpha_num: () =>
    `kenttä voi sisältää vain kirjamia ja numeroita.`,
  alpha_spaces: () =>
    `kenttä voi sisältää vain kirjamia, numeroita ja välilyöntejä.`,
  alpha: () => `kenttä voi sisältää vain kirjamia.`,
  before: (field, [target, inclusion]) =>
    `täytyy olla ennen ${inclusion ? 'tai yhtä suuri kuin' : ''} ${target}.`,
  between: (field, [min, max]) =>
    `kentän on oltava välillä ${min} - ${max}.`,
  confirmed: () => `vahvistus ei täsmää.`,
  credit_card: () => `kenttä on virheellinen.`,
  date_between: (field, [min, max]) =>
    `täytyy olla välillä ${min} - ${max}.`,
  date_format: (field, [format]) =>
    `on oltava muodossa ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `kentän täytyy olla numeerinen ja sisältää ${!decimals || decimals === '*' ? '' : decimals
    } desimaalia.`,
  digits: (field, [length]) =>
    `kentän täytyy olla numeerinen ja täsmälleen ${length} merkkiä pitkä.`,
  dimensions: (field, [width, height]) =>
    `koon täytyy olla ${width} px kertaa ${height} px.`,
  email: () => `kentän täytyy sisältää kelvollinen sähkömatkahuoltoosoite.`,
  ext: () => `anna kelvollinen tiedosto.`,
  image: () => `anna kelvollinen kuva.`,
  in: () => `anna kelvollinen arvo.`,
  integer: () => `kentän täytyy olla kokonaisluku.`,
  ip: () => `anna kelvollinen ip-osoite.`,
  length: (field, [length, max]) => {
    if (max) {
      return `pituuden täytyy olla väliltä ${length} ja ${max}.`
    }

    return `pituuden täytyy olla ${length}.`
  },
  max: (field, [length]) =>
    `kentän maksimipituus on ${length} merkkiä.`,
  max_value: (field, [max]) => `arvon täytyy olla korkeintaan ${max}.`,
  mimes: () => `tiedostomuoto ei kelpaa.`,
  min: (field, [length]) =>
    `arvon täytyy olla vähintään ${length} merkkiä pitkä.`,
  min_value: (field, [min]) => `arvon täytyy olla vähiäntään ${min}.`,
  not_in: () => `arvo ei kelpaa`,
  numeric: () => `kenttä voi sisältää ainoastaan numeroita`,
  regex: () => `kentän muoto ei kelpaa`,
  required: () => `kenttä on pakollinen.`,
  size: (field, [size]) =>
    `koon täytyy olla alle ${formatFileSize(size)}.`,
  url: () => `URL on väärässä muodossa.`,
  fullName: () => 'ei kelpaa (etunimi, sukunimi, korkeintaan 20. merkkiä)',
  emailInput: () => 'kentän on oltava kelvollinen sähköMatkahuoltoosoite.',
  fullNamePerCountry: () => 'ei kelpaa (nimi, etunimi ja enintään 18. merkkiä)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `on liian pitkä`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'fi',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/fi.js